
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import OrderProductSelector from './OrderProductSelector';
import { OrderProductsList } from './order-products-list';
import { Badge } from "@/components/ui/badge";
import { Store } from "lucide-react";

interface OrderFormProductsSectionProps {
  products: any[];
  totalAmount: number;
  handleAddProduct: (product: any) => void;
  handleRemoveProduct: (productId: string) => void;
  shopId?: string;
  shopName?: string;
}

const OrderFormProductsSection = ({
  products,
  totalAmount,
  handleAddProduct,
  handleRemoveProduct,
  shopId,
  shopName
}: OrderFormProductsSectionProps) => {
  // Determine the currency to display in the total
  // Use the currency of the first product, or DZD as fallback
  const mainCurrency = products.length > 0 && products[0].currency 
    ? products[0].currency 
    : "DZD";
  
  // Get currency symbol
  const getCurrencySymbol = (currencyCode: string) => {
    switch(currencyCode) {
      case 'EUR': return '€';
      case 'USD': return '$';
      case 'GBP': return '£';
      case 'DZD': return 'DA';
      case 'MAD': return 'MAD';
      case 'TND': return 'TND';
      default: return currencyCode;
    }
  };
  
  const currencySymbol = getCurrencySymbol(mainCurrency);
  
  return (
    <Card className="md:col-span-3">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Produits</CardTitle>
        {shopName && (
          <Badge variant="outline" className="flex items-center gap-1 px-2 py-1 text-sm bg-indigo-50 text-indigo-700 border-indigo-200">
            <Store className="h-3.5 w-3.5" />
            <span>{shopName}</span>
          </Badge>
        )}
      </CardHeader>
      <CardContent>
        <OrderProductSelector 
          onAddProduct={handleAddProduct} 
          shopId={shopId}
        />
        
        <div className="mt-6">
          <OrderProductsList 
            products={products} 
            onRemoveProduct={handleRemoveProduct} 
          />
        </div>
        
        <div className="mt-8 flex justify-between items-center border-t pt-4">
          <span className="text-lg font-medium">Total</span>
          <span className="text-xl font-bold">{totalAmount.toFixed(2)} {currencySymbol}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default OrderFormProductsSection;
